import React from 'react';
import {Button} from 'antd';
import HeroSection from '../../components/site/HeroSection';
import ProductProofBar from '../../components/site/ProductProofBar';
import SectionTitle from '../../components/site/SectionTitle';
import SiteLink from '../../components/site/SiteLink';
import SplitShowcase from '../../components/site/SplitShowcase';
import {useWaitlist} from '../../components/site/WaitlistModal';
import {useSiteContent} from './siteContent';
import styles from './SitePages.module.css';

const ProductPage: React.FC = () => {
    const {heroMetrics, primaryCta, productPage, resources, waitlistCta} = useSiteContent();
    const {openWaitlist} = useWaitlist();
    const directionIds = ['assist-trading', 'auto-trading', 'asset-allocation'];

    return (
        <div className={styles.page}>
            <section className={styles.section}>
                <HeroSection
                    description={productPage.hero.description}
                    eyebrow={productPage.hero.eyebrow}
                    metrics={heroMetrics}
                    panelDescription={productPage.hero.panelDescription}
                    panelLabel={productPage.hero.panelLabel}
                    panelTitle={productPage.hero.panelTitle}
                    title={productPage.hero.title}
                />
            </section>

            <section className={styles.section}>
                <ProductProofBar items={resources.proofBarItems}/>
            </section>

            <section className={styles.section}>
                <SectionTitle
                    description={productPage.hero.description}
                    eyebrow={productPage.hero.eyebrow}
                    title={productPage.hero.title}
                />
                <div className={`${styles.storyStack} site-section`}>
                    {productPage.directions.map((story, index) => (
                        <div className={styles.anchorSection} id={directionIds[index]} key={story.title}>
                            <SplitShowcase block={story} reverse={index % 2 === 1}/>
                        </div>
                    ))}
                </div>
            </section>

            <section className={styles.section}>
                <article className={`site-card ${styles.ctaPanel}`}>
                    <div>
                        <span className="site-eyebrow">{productPage.hero.panelLabel}</span>
                        <h3>{productPage.hero.panelTitle}</h3>
                        <p>{productPage.hero.panelDescription}</p>
                    </div>
                    <div className={styles.ctaActions}>
                        <SiteLink className={styles.ctaButton} to={primaryCta.path}>{primaryCta.label}</SiteLink>
                        <Button size="large" onClick={openWaitlist}
                                style={{height: 48, paddingInline: 32, fontSize: 16}}>
                            {waitlistCta.label}
                        </Button>
                    </div>
                </article>
            </section>
        </div>
    );
};

export default ProductPage;
